// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

import styles from 'components/KeyFacts.scss';

import Icon from 'Common/Icon';
import { toCapitalize } from 'Common/string';
import { connect } from 'react-redux';
import { valueOrNA } from 'Common/valueOrNA';

/**
 * <KeyFacts /> component.
 */
class KeyFacts extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    data: PropTypes.shape({
      year: PropTypes.number,
      mileage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      fuelType: PropTypes.string,
      transmission: PropTypes.string,
      doors: PropTypes.string,
      engineSize: PropTypes.string
    }),
    item: PropTypes.object
  };

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      item: state.listing
    };
  }

  /**
   * Renders <KeyFacts /> component.
   *
   * @return {JSX} - renders KeyFacts.
   */
  render(): Node {
    const { item } = this.props;
    const year = item.year;
    const mileage = valueOrNA(item, 'mileage').toLocaleString('en');
    const fuelType = valueOrNA(item.derivative, 'fuelType');
    const transmission = valueOrNA(item.derivative, 'transmission');
    const engineSize = valueOrNA(item.technical, 'cc');
    const doors = valueOrNA(item.derivative, 'doors');

    const { classKeyFacts } = styles;
    if (!item) {
      return null;
    }
    return (
      <div className={classKeyFacts}>
        <ul>
          <li>
            <Icon
              iconName={'calendar'}
              size={'medium'}
              className={styles.icon}
            />
            {year}
          </li>
          <li>
            <Icon
              iconName={'gearbox'}
              size={'medium'}
              className={styles.icon}
            />
            {toCapitalize(transmission)}
          </li>
          <li>
            <Icon iconName={'road'} size={'medium'} className={styles.icon} />
            {mileage} Miles
          </li>
          <li>
            <Icon iconName={'door'} size={'medium'} className={styles.icon} />
            {doors} Doors
          </li>
          <li>
            <Icon
              iconName={'fuel-tank'}
              size={'medium'}
              className={styles.icon}
            />
            {toCapitalize(fuelType)}
          </li>
          <li>
            <Icon iconName={'engine'} size={'medium'} className={styles.icon} />
            {engineSize !== 'N/A' ? `${engineSize} cc` : engineSize}
          </li>
        </ul>
      </div>
    );
  }
}

// $FlowFixMe
export default connect(KeyFacts.mapStateToProps, null)(KeyFacts);



// WEBPACK FOOTER //
// ./src/Detail/KeyFacts/index.js